import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { Dropdown } from 'primereact/dropdown';
import DashboardService from '../services/DashboardService';
import WareHouseMaterService from '../services/WareHouseMaterService';
import ApiService from '../services/apiService';
import { SelectButton } from 'primereact/selectbutton';
import Loaders from './../template/Loaders';
export default class Dashboard extends Component {

  constructor(props) {
    super(props);

    this.state = {
      TotalMapping: 0,
      TotalDeMapping: 0,
      TotalDamage: 0,
      updateLoader: false,
      TotalGenerated: 0,
      Months: [],
      DeMappings: [],
      Mappings: [],
      dropDownValue: '',
      NumberIssue: [],
      Damage: [],
      largestNumber: 0,
      factoryDDL: [],
      isAdmin: true,
      isPreprintedValue: "Static Qr Mapping",
      isPreprinted: false
    }
    this.WareHouseMaterService = new WareHouseMaterService();
    this.DashboardService = new DashboardService();
    this.ApiService = new ApiService();
    this.setPreprintedValue = this.setPreprintedValue.bind(this);
  }
  //trigger api function on page call
  componentDidMount() {
    setTimeout(() => {
      if (this.ApiService.getIsAdmin() == "true") {
        this.setState({
          isAdmin: false
        });
      }
      this.GetAllFactory(0);
      this.GetDashboardData('', false);
    }, 100);
  }
  handleChange(e) {
    debugger
    const prefix = e.target.value.Prefix;
    // const prefix = sessionStorage.getItem('Prefix')
    this.setState({
      dropDownValue: e.target.value
    });

    this.GetDashboardData(prefix, false);
  }
  // Get Dashboard Data
  GetDashboardData(prefix, isPreprinted) {
    debugger
    console.log(sessionStorage.getItem('Prefix'));
    const formdata = { prefix: prefix, isPreprinted: isPreprinted };
    this.DashboardService.GetDashboardData(formdata).then(data => {

      const resdata = data.data;
      //if ResponseCode is 200
      if (resdata.ResponseCode === '200') {
        this.setState({ updateLoader: true });
        const res = resdata.ResponseData;
        const DashboardCount = res.DashboardCount;
        const MonthName = res.MonthName;
        const DeMappingList = res.DeMappingList;
        const MappingList = res.MappingList;
        const NumberList = res.NumberList;
        const DamageNumberList = res.DamageList;
        //DashboardCount not null
        if (DashboardCount != null) {
          this.setState({
            TotalMapping: DashboardCount.TotalMapping,
            TotalDeMapping: DashboardCount.TotalDeMapping,
            TotalDamage: DashboardCount.TotalDamage,
            TotalGenerated: DashboardCount.TotalGenerate
          });

          var largest = 0;
          const array = [DashboardCount.TotalMapping, DashboardCount.TotalDeMapping, DashboardCount.TotalDamage, DashboardCount.TotalIssue];
          for (let i = 0; i <= largest; i++) {
            if (array[i] > largest) {
              var largest = array[i];
            }
          }

          this.setState({
            largestNumber: largest
          });
        }
        //MonthName not null
        if (MonthName != null && MonthName.length > 0) {
          this.setState({
            Months: MonthName
          });
        }
        //DeMappingList not null
        if (DeMappingList != null && DeMappingList.length > 0) {
          this.setState({
            DeMappings: DeMappingList
          });
        }
        //MappingList not null
        if (MappingList != null && MappingList.length > 0) {
          this.setState({
            Mappings: MappingList
          });
        }
        //NumberList not null
        if (NumberList != null && NumberList.length > 0) {
          this.setState({
            NumberIssue: NumberList
          });
        }
        //DamageNumberList not null
        if (DamageNumberList != null && DamageNumberList.length > 0) {
          this.setState({
            Damage: DamageNumberList
          });
        }

      }
    });
  }
  GetAllFactory(compId) {
    this.WareHouseMaterService.GetWareHouseDDL(compId).then(data => {
      debugger
      const resdata = data.data;
      //if resdata is not null state of wareHouseDDL will be set with ResponseData
      if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

        const factory = resdata.ResponseData.filter(x => x.IsFactory == true);
        this.setState({
          factoryDDL: factory,
        });
      }
    });
  }
  /// to set isPreprinted
  setPreprintedValue(e) {

    this.setState({
      isPreprintedValue: e.value,
      isPreprinted: e.value == "Static Qr Mapping" ? false : true
    }, () => {

      this.GetDashboardData('', this.state.isPreprinted);

    });
  }
  // return HTML
  render() {
    const options = ['Static Qr Mapping', 'PrePrinted Qr Mapping']; // use for statis and preprinted Qr code
    // const options = [];

    const data = {

      labels: this.state.Months,

      datasets: [

        {
          label: 'Number Generated',
          data: this.state.NumberIssue,
          fill: false,
          borderColor: '#4bc0c0'
        },

        {
          label: 'Damage',
          data: this.state.Damage,
          fill: false,
          borderColor: '#c74e1a'
        },

        {
          label: 'Product Mapping',
          data: this.state.Mappings,
          fill: false,
          borderColor: '#97A5A5'
        },
        {
          label: 'Product De-Mapping',
          data: this.state.DeMappings,
          fill: false,
          borderColor: '#150e0b'
        },


      ]
    };

    return (

      <>
        <Loaders loader={this.state.updateLoader} />
        <SelectButton value={this.state.isPreprintedValue} className="custom-tab" options={options} onChange={this.setPreprintedValue} />
        <div className="box" hidden={this.state.isAdmin}>

          <div className="row">
            <span className="pl-4 pt-2">
              Select factory
            </span>
            <div className="col-md-6 mb-2">
              <Dropdown appendTo={document.getElementById('root')} optionLabel="FirmName" value={this.state.dropDownValue} onChange={e => { this.handleChange(e) }} className="form-control" placeholder="-Select-" name="WareHouseId" options={this.state.factoryDDL} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="box">
              <h4>Product Mapping</h4>
              <h3>{this.state.TotalMapping}</h3>

              <div className="progress">
                <div className="progress-bar" role="progressbar" aria-valuenow="70"
                  aria-valuemin="0" aria-valuemax="100" style={{ "width": this.state.TotalMapping / this.state.largestNumber + "%" }}>
                  <span className="sr-only">{this.state.TotalMapping / this.state.largestNumber}% Complete</span>
                </div>
              </div>

            </div>
          </div>
          <div className="col-md-3">
            <div className="box">
              <h4>Product De Mapping</h4>
              <h3>{this.state.TotalDeMapping}</h3>
              <div className="progress">
                <div className="progress-bar" role="progressbar" aria-valuenow="70"
                  aria-valuemin="0" aria-valuemax="100" style={{ "width": this.state.TotalDeMapping / this.state.largestNumber + "%" }}>
                  <span className="sr-only">{this.state.TotalDeMapping / this.state.largestNumber}% Complete</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="box">
              <h4>Product Damage</h4>
              <h3>{this.state.TotalDamage}</h3>
              <div className="progress">
                <div className="progress-bar" role="progressbar" aria-valuenow="70"
                  aria-valuemin="0" aria-valuemax="100" style={{ "width": this.state.TotalDamage / this.state.largestNumber + "%" }}>
                  <span className="sr-only">{this.state.TotalDamage / this.state.largestNumber}% Complete</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="box">
              <h4>Number Generated</h4>
              <h3>{this.state.TotalGenerated}</h3>
              <div className="progress">
                <div className="progress-bar" role="progressbar" aria-valuenow="70"
                  aria-valuemin="0" aria-valuemax="100" style={{ "width": this.state.TotalGenerated / this.state.largestNumber + "%" }}>
                  <span className="sr-only">{this.state.TotalGenerated / this.state.largestNumber}% Complete</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 mb-5 mt-5">
            <Chart type="line" data={data} />
          </div>
          {/* <div className="col-md-12">
            <div className="white-box">
              <h3>USERS</h3>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Firstname</th>
                    <th>Lastname</th>
                    <th>Email</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>John</td>
                    <td>Doe</td>
                    <td>john@example.com</td>
                    <td>1-770-736-8031 x56442</td>
                  </tr>
                  <tr>
                    <td>Mary</td>
                    <td>Moe</td>
                    <td>mary@example.com</td>
                    <td>010-692-6593 x09125</td>
                  </tr>
                  <tr>
                    <td>July</td>
                    <td>Dooley</td>
                    <td>july@example.com</td>
                    <td>1-463-123-4447</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> */}
        </div>
      </>
    )
  }
}
